import { useMemo, useState } from "react";
import { useGetActivityTimeline } from "../../api/useGetActivityTimeline";
import { useGetActivityTimelineCounts } from "../../api/useGetActivityTimelineCounts";
import { flattenUniquePages } from "../../../../utils/pagination";
import type { ActivityTimelineFeed } from "../../../../types";
import type { TimelineEntityTypeFilter } from "./useActivityTimelineFilter";

// The feed unions several tables, so ids are only unique per entity type.
export function getTimelineItemKey(item: ActivityTimelineFeed) {
  return `${item.entity_type}-${item.id}`;
}

type Props = {
  subTopicId?: string;
  providerId?: string;
};

export function useActivityTimeline(props: Props) {
  const [filter, setFilter] = useState<TimelineEntityTypeFilter>('all');
  const filters = { subTopicId: props.subTopicId, providerId: props.providerId };

  // The type filter runs server-side so each tab pages through its own items.
  const {
    data,
    isLoading,
    error,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError,
    fetchNextPage,
  } = useGetActivityTimeline(filters, filter);

  const { data: counts } = useGetActivityTimelineCounts(filters);

  const items = useMemo(() => flattenUniquePages(data?.pages, getTimelineItemKey), [data]);

  function handleLoadMore() {
    fetchNextPage();
  }

  return {
    items,
    isLoading,
    error,
    currentFilter: filter,
    setFilter,
    counts,
    hasMore: Boolean(hasNextPage),
    isLoadingMore: isFetchingNextPage,
    isLoadMoreError: isFetchNextPageError,
    handleLoadMore,
  };
}
